/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ChevronUpLg: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="chevron-up-lg" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M129.9366666666667 493.3966666666668L680 1043.46L1230.0633333333333 493.3966666666666L1149.9366666666665 413.27L680 883.2066666666667L210.0633333333334 413.27L129.9366666666667 493.3966666666666z" : "M103.9493333333333 394.7173333333334L544 834.768L984.0506666666668 394.7173333333333L919.9493333333334 330.6159999999999L544 706.5653333333333L168.0506666666667 330.6159999999999L103.9493333333334 394.7173333333333z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ChevronUpLg.displayName = `Blueprint5.Icon.ChevronUpLg`;
export default ChevronUpLg;
